// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"LanguageToggle_toggleWrapper__6C7FO","slider":"LanguageToggle_slider__iwUMB","right":"LanguageToggle_right__l3t86","lang":"LanguageToggle_lang__o2oR3","active":"LanguageToggle_active__bAxyG"};
    if(module.hot) {
      // 1763464084402
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  